export class Position {

    x: number;
    y: number;
    w: number;
    h: number;

    static createEmptyPosition(): Position {
        const position = new Position();
        position.x = 0;
        position.y = 0;
        position.w = 0;
        position.h = 0;

        return position;
    }

    static toPosition(object: { x: number; y: number; w: number; h: number }): Position {
        const position = new Position();
        position.x = object.x;
        position.y = object.y;
        position.w = object.w;
        position.h = object.h;

        return position;
    }

    moveY(value: number): void {
        this.y += value;
    }

    moveX(value: number): void {
        this.x += value;
    }
}
